import { FetchError } from "./errors.ts";

const AUTH_ERROR_PATTERN = /authenticat(ed|ion)\s+failed/i;

export function throwErrors<T>(response: Response, data?: T, error?: unknown): asserts data is NonNullable<T> {
  if (error) {
    const message = String(error);
    const status = AUTH_ERROR_PATTERN.test(message) ? 401 : response.status;
    // FIXME Check why we don't logout there?
    throw new FetchError(status, message);
  }

  if (data == undefined && !(response.status >= 200 && response.status < 300)) {
    throw new FetchError(response.status, "No data has been returned from the server");
  }
}
